<section class="error-load-user-info">
    <div mat-dialog-title>
        <span mat-dialog-close class="material-icons error-load-user-info__close">close</span>
    </div>
    <span class="material-icons error-load-user-info__icon">close</span>
    <h1 class="error-load-user-info__title">{{ errorTitle }}</h1>
    
    <p class="error-load-user-info__description">
        Estamos trabalhando para resolver esse problema.
        Por favor, tente novamente mais tarde e, se o erro persistir, entre em contato com a nossa equipe de atendimento.
    </p>
    
    <seds-basic-button
        mat-dialog-close
        class="btn-sair__fade-in"
        data-test="btn-sair"
        [size]="smallButton"
        title="Sair"
    ></seds-basic-button>
</section>
